// extracted by css-extract-rspack-plugin
export default {"ToastItem":"ToastItem-vT4SJM","toastItem":"ToastItem-vT4SJM","danger":"danger-qQhkwV","success":"success-CXL_Tt"};